import { useEffect, useState } from "react";
import { AgentOSLayout } from "@/components/agent-os/AgentOSLayout";
import { apiFetch, Pill, Spinner } from "@/components/agent-os/shared";

export default function AgentOSTools() {
    const [tools, setTools] = useState(null);
    const load = () => apiFetch("/tools").then((r) => (r.ok ? r.json() : [])).then(setTools);
    useEffect(() => { load(); }, []);

    const toggle = async (tool) => {
        await apiFetch(`/tools/${tool.tool_id}`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ enabled: !tool.enabled }) });
        load();
    };

    return (
        <AgentOSLayout title="Tool Registry" subtitle="Provider-independent tools with schemas, permissions, risk levels, approval rules and safe disabled defaults.">
            {!tools ? <Spinner /> : (
                <div className="grid gap-5 xl:grid-cols-2" data-testid="tool-registry-list">
                    {tools.map((tool) => (
                        <article key={tool.tool_id} data-testid={`tool-${tool.tool_id}`} className="border border-ink/10 bg-ivory p-6">
                            <div className="flex flex-wrap items-start justify-between gap-4">
                                <div>
                                    <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-champagne">{tool.category}</p>
                                    <h2 className="mt-2 font-serif text-2xl font-medium">{tool.tool_id}</h2>
                                </div>
                                <div className="flex gap-2"><Pill value={tool.risk_level} risk /><Pill value={tool.enabled ? "active" : "disabled"} /></div>
                            </div>
                            <p className="mt-4 text-sm leading-relaxed text-ink/60">{tool.description}</p>
                            <div className="mt-5 grid gap-3 text-xs text-ink/55 sm:grid-cols-2">
                                <p>Implemented: {tool.implemented ? "yes" : "no"}</p>
                                <p>Approval: {tool.approval_requirements.required ? "required" : "not required"}</p>
                                <p>Permission: {tool.permission_requirements.join(", ")}</p>
                                <p>Logging: {tool.logging_requirements.replace(/_/g, " ")}</p>
                            </div>
                            <button type="button" data-testid={`tool-toggle-${tool.tool_id}`} onClick={() => toggle(tool)} className="mt-6 border border-ink/20 px-4 py-2.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-ink/60 transition-colors hover:border-forest hover:text-forest">
                                {tool.enabled ? "Disable" : "Enable"}
                            </button>
                        </article>
                    ))}
                </div>
            )}
        </AgentOSLayout>
    );
}
